import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { useState } from 'react'
import { BrowserRouter as Router } from "react-router-dom";
import Routes from './Routes'
import { darkTheme, lightTheme } from './Styles/theme'
import { ToastProvider } from './Hooks/ToasContext'
import { UserProvider } from './Hooks/ContextUser'
import { AuthProvider } from './Hooks/Auth'
import { HooksProvider } from './Hooks';

function App () {
  const [darkMode, setDarkMode] = useState(false)

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <Router>
        <HooksProvider>
            <ToastProvider>
              <Routes />
            </ToastProvider>
        </HooksProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App